import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const HINTS = {
  sheetSize: "The roll width and length your designs print on. Fixed sizes are a flat price; the custom preset is $14.50 per square foot.",
  customLength: "How long the sheet should be (min 2\"). Price = width × length ÷ 144 × $14.50.",
  templates: "Save this layout under a name to reuse it. Load = edit again; Reorder = load and add to cart in one click.",
  upload: "PNG, JPEG or PDF. Transparent PNGs at 300 DPI give the crispest DTF print.",
  dpi: "Print resolution = image pixels ÷ printed inches. 300 is ideal, 150+ is fine, under 150 prints blurry.",
  unit: "Enter sizes in inches or in pixels at 300 DPI (900 px = 3\").",
  aspectLock: "On: width and height scale together so the design never distorts. Off: stretch each side independently.",
  slider: "Quickly scale the selected image from 1\" up to the full sheet width.",
  width: "Exact printed width of the selected image.",
  height: "Exact printed height of the selected image.",
  rotate: "Turn the selected image 90°.",
  duplicate: "Make one copy next to the selected image.",
  delete: "Remove the selected image from the sheet.",
  removeBg: "Auto-erase the background around the selected image so only the design prints.",
  copies: "Add this many copies (1–50) of the selected image at once.",
  fillSheet: "Tile the selected image, at its current size, across all empty space.",
  autoNest: "Rearrange every image to pack tightly with a 0.2\" gap — less sheet, lower price.",
  notes: "Anything the printer should know: gaps, finish, colour matching, call before printing…",
  qty: "How many identical copies of this whole sheet to print.",
  price: "Updates live as you change sheet size and quantity.",
};

export const FieldHint = ({ text, testid, side = "top" }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" aria-label="Help" data-testid={testid} onClick={(e) => e.preventDefault()} className="inline-flex text-zinc-500 hover:text-[#22c3d6] transition-colors align-middle ml-1"><Info size={12} /></button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-[240px] bg-[#1e222d] border border-zinc-700 text-zinc-200 leading-relaxed">{text}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
